var contentListAjax = false; 

var initializeContentListBlock = function(block){
    
    const blockId = block.attr('id');
    if (!blockId) {
        console.error('Block is missing ID attribute:', block);
        return;
    }
    console.log('Initializing content list block', blockId, block);
    
    // Check if we have args for this block
    if (!contentArgs || !contentArgs[blockId]) {
        console.error('No content args found for block:', blockId);
        return;
    }
    
    const args = contentArgs[blockId];
    console.log('Content args for block:', args);
    
    // Set up filter change handlers
    

    // Initialize event toggle buttons if they exist
    const eventToggleButtons = block.find('.event-toggle-buttons .event-toggle');
    if (eventToggleButtons.length) {
        eventToggleButtons.on('click', function(e) {
            e.preventDefault();
            const $button = jQuery(this);
            if ($button.hasClass('active')) return; // Don't do anything if already active
            
            const showType = $button.data('show');
            eventToggleButtons.removeClass('active');
            $button.addClass('active');
            
            // Get block ID and content args
            const blockId = block.attr('id');
            const args = contentArgs[blockId];
            if (!args) {
                console.error('Content args not found for block:', blockId);
                return;
            }
            
            // Update other args to include the event type filter
            const otherArgs = args.otherArgs ? JSON.parse(args.otherArgs) : {};
            if (showType === 'past') {
                const threeMonthsAgo = new Date();
                threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
                otherArgs.show_past = true;
                otherArgs.past_cutoff = threeMonthsAgo.toISOString().split('T')[0];
                otherArgs.order = 'ASC'; // Chronological order for past events
            }
            
            // Reset and reload content
            block.addClass('content-loading');
            
            if (contentListAjax) contentListAjax.abort();
            
            contentListAjax = jQuery.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'plumb_get_content_ajax',
                    terms: args.terms || '[]',
                    search: args.search || '',
                    offset: 0,
                    postType: args.postType,
                    count: args.count || 12,
                    pagination: false,
                    pageNumber: 1,
                    otherArgs: JSON.stringify(otherArgs),
                },
                success: function(results) {
                    var returnData = JSON.parse(results);
                    jQuery('.posts', block).html(returnData['content-items']);
                    block.removeClass('content-loading');
                    
                    // Update contentArgs with new otherArgs
                    args.otherArgs = JSON.stringify(otherArgs);
                    
                    adjustURL(block);
                    contentListAjax = false;
                }
            });
        });
    }


    // Only initialize Slick if this block has a carousel
    if (block.find('.slick').length > 0) {
        // Check if Slick is available
        if (typeof jQuery.fn.slick === 'undefined') {
            console.error('Slick carousel is not loaded');
            return;
        }

        // Initialize Slick carousel
        jQuery('.slick:not(.slick-initialized)', block).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 1,
            slidesPerRow: 1,
            dots: false,
            arrows: true,
            autoplay: false,
            autoplaySpeed: 3000,
            fade: false,
            easing: "linear",
            pauseOnHover: false,
            infinite: false,
            draggable: false,
            swipe: true,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 740,
                    settings: {
                        slidesToShow: 2,
                        centerMode: true,
                    }
                },
                {
                    breakpoint: 490,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
	
	var blockID = block.hasClass("acf-block-preview") ? jQuery(".wp-block-content-list", block).attr("ID") : block.attr("id");
	var contentAjax = false;
	var ajaxLoads = 0;
	
	// Allows image to load in preview window when vars aren't defined
	if(typeof contentArgs === 'undefined') {
		return false;
	}
	
	var postType = contentArgs[blockID].postType;
	var count = parseInt(contentArgs[blockID].count);
	var offset = parseInt(contentArgs[blockID].offset);
	var terms = contentArgs[blockID].terms;
	var search = contentArgs[blockID].search;
	var otherArgs = contentArgs[blockID].otherArgs;
	var button = jQuery(".load-more-content", block);
	var holder = jQuery(".posts", block);
	var paginationHolder = jQuery(".pagination-holder", block);
	var pagination = paginationHolder ? true : false;
	
	// Load more button
	button.on('click', function(){
	
		if(contentListAjax) {
			return false;
		}
	
		offset = count + (ajaxLoads * count);
	
		block.addClass('content-loading');
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs,
			success:function(results){
				
				var returnData = JSON.parse(results);
	
				holder.append(returnData["content-items"]);
				block.removeClass('content-loading');
				
				if(!returnData["remaining-posts"]) {
					button.hide();
				}
	
				ajaxLoads++;
	
				contentListAjax = false;
	
			}
		});
	
	});
	
	// Pagination
	jQuery(block).on("click", ".pagination a[data-page]", function(){
		
		var link = jQuery(this);
		var page = link.attr("data-page");
		
		if(contentListAjax) {
			return false;
		}
		
		offset = (page-1) * count;
		search = jQuery(".plumb-content-search", block).length ? jQuery(".plumb-content-search", block).val() : "";
		terms = gatherSelectedTerms(block);
		
		block.addClass('content-loading');
		
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + page,
			success:function(results){
				
				var returnData = JSON.parse(results);
		
				holder.html(returnData["content-items"]);
				paginationHolder.html(returnData["pagination"]);
				block.removeClass('content-loading');
		
				contentListAjax = false;
		
			}
		});
		
	});
	
	// Term check list
	jQuery('.content-filter', block).on('change', function(e){
	
		e.preventDefault();
		
		if(contentListAjax) {
			return false;
		}
	
		offset = 0;
		ajaxLoads = 0;
		search = '';
		terms = gatherSelectedTerms(block);
	
		block.addClass('content-loading');
		
		jQuery('.plumb-content-search', block).val("");
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + terms + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + 1,
			success:function(results){
				
				var returnData = JSON.parse(results);
				
				holder.html(returnData["content-items"]);
				block.removeClass('content-loading');
				
				if(pagination) {
					paginationHolder.html(returnData["pagination"]);
				}
				
				if(!returnData["remaining-posts"]) {
					button.hide();
				} else {
					button.show();
				}
	
				contentListAjax = false;
				
				adjustURL(block);
	
			}
		});
	
	});
	
	// Search
	jQuery('.plumb-content-search-form', block).on('submit', function(e){
		
		e.preventDefault();
		
		if(contentListAjax) {
			return false;
		}
	
		offset = 0;
		ajaxLoads = 0;
		search = jQuery('.plumb-content-search', block).val();
	
		resetTerms();
	
		jQuery('html').addClass('content-loading');
	
		contentAjax = jQuery.ajax({
			url:"/wp-admin/admin-ajax.php",
			type:'POST',
			data:'action=plumb_get_content_ajax&postType=' + postType + '&count=' + count + '&offset=' + offset + '&terms=' + '&search=' + search + '&otherArgs=' + otherArgs + '&pagination=' + pagination + '&pageNumber=' + 1,
			success:function(results){
				
				var returnData = JSON.parse(results);
	
				holder.html(returnData["content-items"]);
				
				if(pagination) {
					paginationHolder.html(returnData["pagination"]);
				}
				
				block.removeClass('content-loading');
	
				contentListAjax = false;
				
				adjustURL(block);
	
			}
		});
	
	});
	
}

function gatherSelectedTerms(block) {
    var terms = [];
    
    // Group checkboxes by taxonomy
    jQuery('.filter-group', block).each(function(){
        var tax = jQuery(this).data('tax');
        var selectedTerms = [];
        
        // Get all checked boxes in this group
        jQuery('input:checked', this).each(function(){
            selectedTerms.push(jQuery(this).val());
        });
        
        // Only add to terms if we have selections
        if(selectedTerms.length > 0){
            var termObj = {};
            termObj[tax] = selectedTerms.join(',');
            terms.push(termObj);
        }
    });

    return JSON.stringify(terms);
}

function resetTerms() {

	jQuery('.content-filter').each(function(){
		jQuery("option:first-child", this).prop('selected', true);
	});

}

function adjustURL(block) {
	
	var terms = gatherSelectedTerms(block);
	var search = jQuery('.plumb-content-search', block).val();
	var url = new URL(window.location.href);

	if(terms.length > 2) {
		url.searchParams.set('terms', terms);
	} else {
		url.searchParams.delete('terms');
	}
	
	if(search) {
		url.searchParams.set('content-search', search);
	} else {
		url.searchParams.delete('content-search');
	}
	
	history.replaceState({}, "", url);
	
}

// Team member expandable content functionality 
function initializeTeamMembers(block) {

    let activeTeamMember = null;
    let expandedContent = jQuery('.team-expanded-content', block);

    // Handle close button clicks
    jQuery(document).on('click', '.team-expanded-content .close-button', function() {
        const $activeTeamMember = jQuery('.team-member.active', block);
        expandedContent.slideUp(400, function() {
            activeTeamMember = null;
        });
        $activeTeamMember.removeClass('active');
    });

    jQuery('.team-member', block).click(function(e) {
        // Don't trigger if clicking the close button
        if (jQuery(e.target).closest('.close-button').length) {
            return;
        }

        const $clicked = jQuery(this);
        const memberId = $clicked.data('member-id');
        const content = $clicked.find('.team-member-content').html();
        const $row = getRow($clicked);
        
        // If clicking the same member, just toggle
        if (activeTeamMember === memberId) {
            expandedContent.slideUp(400, function() {
                activeTeamMember = null;
            });
            $clicked.removeClass('active');
            return;
        }

        // Remove active class from all members
        jQuery('.team-member', block).removeClass('active');
        
        // Add active class to clicked member
        $clicked.addClass('active');

        // If we already have expanded content showing
        if (activeTeamMember) {
            // Update content and position immediately but keep it hidden
            expandedContent.css('display', 'none');
            expandedContent.html(content);
            insertAfterRow($row);
            expandedContent.slideDown(400);
        } else {
            // First time showing content
            expandedContent.html(content);
            insertAfterRow($row);
            expandedContent.slideDown(400);
        }

        activeTeamMember = memberId;
    });

    // Get the row that contains an element
    function getRow($element) {
        const elementTop = $element.offset().top;
        return jQuery('.team-member', block).filter(function() {
            return jQuery(this).offset().top === elementTop;
        });
    }

    // Insert expanded content after the correct row
    function insertAfterRow($row) {
        const lastInRow = $row.last();
        expandedContent.insertAfter(lastInRow);
    }
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-content-list').each(function(){
        
        initializeContentListBlock(jQuery(this));
        
        if (jQuery(this).find('.team-member').length) {
            initializeTeamMembers(jQuery(this));
        }
        
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=content-list', initializeContentListBlock);
